import React from 'react';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { Widget } from '../../../../Widget';
import { isTableColumnWidget } from '../columns/IsTableColumnWidget';

export function getTableWidgetColumnTitle(column: Widget) {
  if (!isTableColumnWidget(column)) return '';

  return <RichTextAdvancedRender hasCustomFont text={column.label} />;
}
